module.exports = __webpack_public_path__ + "static/img/map1.f9be8d95.jpg";